import { Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { globalStore } from '../../../../../shared/shared.global-service';
import { selectService } from '../../../../store/service/service.selectors';

@Injectable()
export class ServiceWidgetsSettingsStore extends ComponentStoreV2Factory {

    public service = globalStore!.selectSignal(selectService);
}
